module.exports = __webpack_public_path__ + "img/logo-telis.3fd2ce7a.png";